export * from './NotificationBadge';
//# sourceMappingURL=index.js.map